// Generated from runs/default-output-schema.json.
// Keep validation code below in sync if the canonical encounter field schema changes.
export const encounterEntityMappingBaseSchema = {
    "$schema": "https://json-schema.org/draft/2020-12/schema",
    "type": "object",
    "properties": {
        "enctrNo": {
            "type": ["string", "null"],
            "title": "Encounter Number"
        },
        "patMrn": {
            "type": ["string", "null"],
            "title": "Patient MRN"
        },
        "patLastNm": {
            "type": ["string", "null"],
            "title": "Patient Last Name"
        },
        "patFrstNm": {
            "type": ["string", "null"],
            "title": "Patient First Name"
        },
        "patMidNm": {
            "type": ["string", "null"],
            "title": "Patient Middle Name"
        },
        "patSsn": {
            "type": ["string", "null"],
            "title": "Patient SSN"
        },
        "patDob": {
            "type": ["string", "null"],
            "title": "Patient Date of Birth",
            "description": "Use ISO 8601 date format (YYYY-MM-DD)."
        },
        "patZipCd": {
            "type": ["string", "null"],
            "title": "Patient Zip Code"
        },
        "admitDt": {
            "type": ["string", "null"],
            "title": "Admission Date",
            "description": "Admission date only, no time. Use ISO 8601 date format (YYYY-MM-DD)."
        },
        "admitTm": {
            "type": ["string", "null"],
            "title": "Admission Time",
            "description": "Admission time only, no date. Should be in HH:MM format, excluding seconds. Use 24-hour HH:mm format (no seconds)."
        },
        "dischDt": {
            "type": ["string", "null"],
            "title": "Discharge Date",
            "description": "Discharge date only, no time. Use ISO 8601 date format (YYYY-MM-DD)."
        },
        "dischTm": {
            "type": ["string", "null"],
            "title": "Discharge Time",
            "description": "Discharge time only, no date Use 24-hour HH:mm format (no seconds)."
        },
        "purgedInd": {
            "type": ["boolean", "null"],
            "title": "Purged Indicator"
        },
        "purgedDttm": {
            "type": ["string", "null"],
            "title": "Purged Date/Time",
            "description": "Use 24-hour HH:mm format (no seconds)."
        },
        "patAddrLn1": {
            "type": ["string", "null"],
            "title": "Patient Address Line 1"
        },
        "patAddrLn2": {
            "type": ["string", "null"],
            "title": "Patient Address Line 2"
        },
        "patCity": {
            "type": ["string", "null"],
            "title": "Patient City"
        },
        "patStateCd": {
            "type": ["string", "null"],
            "title": "Patient State Code"
        },
        "patCntryCd": {
            "type": ["string", "null"],
            "title": "Patient Country Code"
        },
        "patPhNoHome": {
            "type": ["string", "null"],
            "title": "Patient Home Phone Number",
            "description": "Home phone number Use standardized E.164 format (example: +12145551234)."
        },
        "patPhNoBus": {
            "type": ["string", "null"],
            "title": "Patient Business Phone Number",
            "description": "Business/work phone number Use standardized E.164 format (example: +12145551234)."
        },
        "patPhNoMob": {
            "type": ["string", "null"],
            "title": "Patient Mobile Phone Number",
            "description": "Mobile phone number Use standardized E.164 format (example: +12145551234)."
        },
        "patEmailHome": {
            "type": ["string", "null"],
            "title": "Patient Home Email",
            "description": "Home email address"
        },
        "patEmailBus": {
            "type": ["string", "null"],
            "title": "Patient Business Email",
            "description": "Business/work email address"
        },
        "patDrLicNo": {
            "type": ["string", "null"],
            "title": "Patient Driver's License Number",
            "description": "Driver's license number"
        },
        "patDrLicSt": {
            "type": ["string", "null"],
            "title": "Patient Driver's License State",
            "description": "Driver's license state"
        },
        "patDrLicExp": {
            "type": ["string", "null"],
            "title": "Patient Driver's License Expiration",
            "description": "Driver's license expiration date"
        },
        "patOccup": {
            "type": ["string", "null"],
            "title": "Patient Occupation",
            "description": "Patient's occupation"
        },
        "patPrimLang": {
            "type": ["string", "null"],
            "title": "Patient Primary Language",
            "description": "Patient's primary language"
        },
        "patMaritalStatus": {
            "type": ["string", "null"],
            "title": "Patient Marital Status"
        },
        "patReligion": {
            "type": ["string", "null"],
            "title": "Patient Religion"
        },
        "patGenderCd": {
            "type": ["string", "null"],
            "title": "Patient Gender Code",
            "description": "Allowed values: M, F, U (Unknown/other).",
            "enum": [
                "M",
                "F",
                "U"
            ]
        },
        "patRace": {
            "type": ["string", "null"],
            "title": "Patient Race"
        },
        "patEthnicGrp": {
            "type": ["string", "null"],
            "title": "Patient Ethnic Group"
        },
        "patNationality": {
            "type": ["string", "null"],
            "title": "Patient Nationality"
        },
        "patDeceasedInd": {
            "type": ["boolean", "null"],
            "title": "Patient Deceased Indicator"
        },
        "patDeceasedDt": {
            "type": ["string", "null"],
            "title": "Patient Deceased Date",
            "description": "Use ISO 8601 date format (YYYY-MM-DD)."
        },
        "enctrAdmitTyp": {
            "type": ["string", "null"],
            "title": "Encounter Admit Type"
        },
        "enctrPatClass": {
            "type": ["string", "null"],
            "title": "Encounter Patient Class"
        },
        "enctrPatTyp": {
            "type": ["string", "null"],
            "title": "Encounter Patient Type"
        },
        "enctrHospSvcCd": {
            "type": ["string", "null"],
            "title": "Encounter Hospital Service Code"
        },
        "accDt": {
            "type": ["string", "null"],
            "title": "Accident Date",
            "description": "Use ISO 8601 date format (YYYY-MM-DD)."
        },
        "accCd": {
            "type": ["string", "null"],
            "title": "Accident Code"
        },
        "accDesc": {
            "type": ["string", "null"],
            "title": "Accident Description"
        },
        "accLocn": {
            "type": ["string", "null"],
            "title": "Accident Location"
        },
        "accAutoStCd": {
            "type": ["string", "null"],
            "title": "Accident Auto State Code"
        },
        "accAutoStNm": {
            "type": ["string", "null"],
            "title": "Accident Auto State Name"
        },
        "accJobRelInd": {
            "type": ["string", "null"],
            "title": "Accident Job Related Indicator"
        },
        "accDeathInd": {
            "type": ["string", "null"],
            "title": "Accident Death Indicator"
        },
        "enctrInsuranceDoc": {
            "type": "array",
            "title": "Encounter Insurance Documents",
            "items": {
                "type": "object",
                "properties": {
                    "id": {
                        "type": "string",
                        "title": "ID"
                    },
                    "insurancePlanId": {
                        "type": ["string", "null"],
                        "title": "Insurance Plan ID"
                    },
                    "insurerId": {
                        "type": ["string", "null"],
                        "title": "Insurer ID"
                    },
                    "insurerName": {
                        "type": ["string", "null"],
                        "title": "Insurer Name"
                    },
                    "insurerAddress1": {
                        "type": ["string", "null"],
                        "title": "Insurer Address 1"
                    },
                    "insurerAddress2": {
                        "type": ["string", "null"],
                        "title": "Insurer Address 2"
                    },
                    "insurerCity": {
                        "type": ["string", "null"],
                        "title": "Insurer City"
                    },
                    "insurerPostalCode": {
                        "type": ["string", "null"],
                        "title": "Insurer Postal Code"
                    },
                    "insurerStateAbbrev": {
                        "type": ["string", "null"],
                        "title": "Insurer State Abbreviation"
                    },
                    "insurerContactPerson": {
                        "type": ["string", "null"],
                        "title": "Insurer Contact Person"
                    },
                    "insurerPhone": {
                        "type": ["string", "null"],
                        "title": "Insurer Phone",
                        "description": "Use standardized E.164 format (example: +12145551234)."
                    },
                    "insuredId": {
                        "type": ["string", "null"],
                        "title": "Insured ID",
                        "description": "The ID of the insured"
                    },
                    "insuredGroupEmplId": {
                        "type": ["string", "null"],
                        "title": "Insured Group Employer ID"
                    },
                    "insuredGroupEmplName": {
                        "type": ["string", "null"],
                        "title": "Insured Group Employer Name"
                    },
                    "insuredFirstName": {
                        "type": ["string", "null"],
                        "title": "Insured First Name"
                    },
                    "insuredLastName": {
                        "type": ["string", "null"],
                        "title": "Insured Last Name"
                    },
                    "insuredMiddleName": {
                        "type": ["string", "null"],
                        "title": "Insured Middle Name"
                    },
                    "insuredSuffix": {
                        "type": ["string", "null"],
                        "title": "Insured Suffix"
                    },
                    "insuredRelToPatient": {
                        "type": ["string", "null"],
                        "title": "Insured Relationship to Patient"
                    },
                    "insuredDOB": {
                        "type": ["string", "null"],
                        "title": "Insured Date of Birth",
                        "description": "Use ISO 8601 date format (YYYY-MM-DD)."
                    },
                    "insuredSSN": {
                        "type": ["string", "null"],
                        "title": "Insured SSN"
                    },
                    "insuredAddress1": {
                        "type": ["string", "null"],
                        "title": "Insured Address 1"
                    },
                    "insuredAddress2": {
                        "type": ["string", "null"],
                        "title": "Insured Address 2"
                    },
                    "insuredCity": {
                        "type": ["string", "null"],
                        "title": "Insured City"
                    },
                    "insuredPostalCode": {
                        "type": ["string", "null"],
                        "title": "Insured Postal Code"
                    },
                    "insuredStateAbbrev": {
                        "type": ["string", "null"],
                        "title": "Insured State Abbreviation"
                    },
                    "insuredPhone": {
                        "type": ["string", "null"],
                        "title": "Insured Phone",
                        "description": "Use standardized E.164 format (example: +12145551234)."
                    },
                    "insuredEmail": {
                        "type": ["string", "null"],
                        "title": "Insured Email"
                    },
                    "insuredMaritalStatus": {
                        "type": ["string", "null"],
                        "title": "Insured Marital Status"
                    },
                    "insuredPrimLanguage": {
                        "type": ["string", "null"],
                        "title": "Insured Primary Language"
                    },
                    "insuredJobTitle": {
                        "type": ["string", "null"],
                        "title": "Insured Job Title"
                    },
                    "insuredJobStatus": {
                        "type": ["string", "null"],
                        "title": "Insured Job Status"
                    },
                    "insuredEmployerName": {
                        "type": ["string", "null"],
                        "title": "Insured Employer Name"
                    },
                    "insuredEmployerStatus": {
                        "type": ["string", "null"],
                        "title": "Insured Employer Status"
                    },
                    "insuredGender": {
                        "type": ["string", "null"],
                        "title": "Insured Gender",
                        "description": "Allowed values: M, F, U (Unknown/other).",
                        "enum": [
                            "M",
                            "F",
                            "U"
                        ]
                    },
                    "insuredMaleGender": {
                        "type": ["boolean", "null"],
                        "title": "Insured Male Gender"
                    },
                    "patRelToInsuredId": {
                        "type": ["string", "null"],
                        "title": "Patient Relationship to Insured ID"
                    },
                    "patRelToInsuredText": {
                        "type": ["string", "null"],
                        "title": "Patient Relationship to Insured Text"
                    },
                    "groupNumber": {
                        "type": ["string", "null"],
                        "title": "Group Number"
                    },
                    "groupName": {
                        "type": ["string", "null"],
                        "title": "Group Name"
                    },
                    "planEffectiveDate": {
                        "type": ["string", "null"],
                        "title": "Plan Effective Date",
                        "description": "Use ISO 8601 date format (YYYY-MM-DD)."
                    },
                    "planExpirationDate": {
                        "type": ["string", "null"],
                        "title": "Plan Expiration Date",
                        "description": "Use ISO 8601 date format (YYYY-MM-DD)."
                    },
                    "authorizationCode": {
                        "type": ["string", "null"],
                        "title": "Authorization Code"
                    },
                    "authorizationDate": {
                        "type": ["string", "null"],
                        "title": "Authorization Date",
                        "description": "Use ISO 8601 date format (YYYY-MM-DD)."
                    },
                    "planType": {
                        "type": ["string", "null"],
                        "title": "Plan Type"
                    },
                    "companyPlanCode": {
                        "type": ["string", "null"],
                        "title": "Company Plan Code"
                    },
                    "policyNumber": {
                        "type": ["string", "null"],
                        "title": "Policy Number"
                    },
                    "policyLimitAmount": {
                        "type": ["string", "null"],
                        "title": "Policy Limit Amount"
                    },
                    "policyLimitDays": {
                        "type": ["string", "null"],
                        "title": "Policy Limit Days"
                    },
                    "verificationDateTime": {
                        "type": ["string", "null"],
                        "title": "Verification Date/Time",
                        "description": "Use 24-hour HH:mm format (no seconds)."
                    },
                    "verificationBy": {
                        "type": ["string", "null"],
                        "title": "Verification By"
                    },
                    "verificationStatus": {
                        "type": ["string", "null"],
                        "title": "Verification Status"
                    },
                    "assignmentOfBenefits": {
                        "type": ["string", "null"],
                        "title": "Assignment of Benefits"
                    },
                    "coordOfBenefits": {
                        "type": ["string", "null"],
                        "title": "Coordination of Benefits"
                    },
                    "coordOfBenefitsPriority": {
                        "type": ["string", "null"],
                        "title": "Coordination of Benefits Priority"
                    },
                    "noticeOfAdmissionFlag": {
                        "type": ["string", "null"],
                        "title": "Notice of Admission Flag"
                    },
                    "noticeOfAdmissionDate": {
                        "type": ["string", "null"],
                        "title": "Notice of Admission Date",
                        "description": "Use ISO 8601 date format (YYYY-MM-DD)."
                    },
                    "releaseInformationCode": {
                        "type": ["string", "null"],
                        "title": "Release Information Code"
                    },
                    "preAdmissionCert": {
                        "type": ["string", "null"],
                        "title": "Pre-Admission Certification"
                    },
                    "typeOfAgreementCode": {
                        "type": ["string", "null"],
                        "title": "Type of Agreement Code"
                    },
                    "billingStatus": {
                        "type": ["string", "null"],
                        "title": "Billing Status"
                    },
                    "lifetimeReserveDays": {
                        "type": ["string", "null"],
                        "title": "Lifetime Reserve Days",
                        "description": "Use 24-hour HH:mm format (no seconds)."
                    },
                    "delayBeforeLRDay": {
                        "type": ["string", "null"],
                        "title": "Delay Before Lifetime Reserve Day",
                        "description": "Use 24-hour HH:mm format (no seconds)."
                    },
                    "roomRateSemiPrivate": {
                        "type": ["string", "null"],
                        "title": "Room Rate Semi-Private"
                    },
                    "roomRatePrivate": {
                        "type": ["string", "null"],
                        "title": "Room Rate Private"
                    }
                }
            }
        },
        "enctrDiagnosisDoc": {
            "type": "array",
            "title": "Encounter Diagnosis",
            "items": {
                "type": "object",
                "properties": {
                    "id": {
                        "type": "string",
                        "title": "ID"
                    },
                    "codingMethod": {
                        "type": ["string", "null"],
                        "title": "Coding Method"
                    },
                    "diagCode": {
                        "type": ["string", "null"],
                        "title": "Diagnosis Code",
                        "description": "Encounter diagnosis code in ICD-10 format."
                    },
                    "diagDesc": {
                        "type": ["string", "null"],
                        "title": "Diagnosis Description"
                    },
                    "diagDate": {
                        "type": ["string", "null"],
                        "title": "Diagnosis Date",
                        "description": "Use ISO 8601 date format (YYYY-MM-DD)."
                    },
                    "diagTime": {
                        "type": ["string", "null"],
                        "title": "Diagnosis Time",
                        "description": "Use 24-hour HH:mm format (no seconds)."
                    },
                    "diagType": {
                        "type": ["string", "null"],
                        "title": "Diagnosis Type"
                    }
                }
            }
        },
        "enctrRelationsDoc": {
            "type": "array",
            "title": "Patient Relations",
            "items": {
                "type": "object",
                "properties": {
                    "id": {
                        "type": "string",
                        "title": "ID"
                    },
                    "lastName": {
                        "type": ["string", "null"],
                        "title": "Last Name"
                    },
                    "firstName": {
                        "type": ["string", "null"],
                        "title": "First Name"
                    },
                    "middleName": {
                        "type": ["string", "null"],
                        "title": "Middle Name"
                    },
                    "address1": {
                        "type": ["string", "null"],
                        "title": "Address 1"
                    },
                    "address2": {
                        "type": ["string", "null"],
                        "title": "Address 2"
                    },
                    "city": {
                        "type": ["string", "null"],
                        "title": "City"
                    },
                    "stateAbbrev": {
                        "type": ["string", "null"],
                        "title": "State Abbreviation"
                    },
                    "postalCode": {
                        "type": ["string", "null"],
                        "title": "Postal Code"
                    },
                    "countryCode": {
                        "type": ["string", "null"],
                        "title": "Country Code"
                    },
                    "homePhone": {
                        "type": ["string", "null"],
                        "title": "Home Phone",
                        "description": "Use standardized E.164 format (example: +12145551234)."
                    },
                    "businessPhone": {
                        "type": ["string", "null"],
                        "title": "Business Phone",
                        "description": "Use standardized E.164 format (example: +12145551234)."
                    },
                    "maritalStatus": {
                        "type": ["string", "null"],
                        "title": "Marital Status"
                    },
                    "gender": {
                        "type": ["string", "null"],
                        "title": "Gender",
                        "description": "Allowed values: M, F, U (Unknown/other).",
                        "enum": [
                            "M",
                            "F",
                            "U"
                        ]
                    },
                    "dob": {
                        "type": ["string", "null"],
                        "title": "Date of Birth",
                        "description": "Use ISO 8601 date format (YYYY-MM-DD)."
                    },
                    "primaryLanguage": {
                        "type": ["string", "null"],
                        "title": "Primary Language"
                    },
                    "jobTitle": {
                        "type": ["string", "null"],
                        "title": "Job Title"
                    },
                    "jobStatus": {
                        "type": ["string", "null"],
                        "title": "Job Status"
                    },
                    "relToPatient": {
                        "type": ["string", "null"],
                        "title": "Relationship to Patient",
                        "description": "Relationship to the patient"
                    },
                    "ssn": {
                        "type": ["string", "null"],
                        "title": "SSN"
                    }
                }
            }
        },
        "enctrGuarantorDoc": {
            "type": "array",
            "title": "Guarantors",
            "items": {
                "type": "object",
                "properties": {
                    "id": {
                        "type": "string",
                        "title": "ID"
                    },
                    "lastName": {
                        "type": ["string", "null"],
                        "title": "Last Name"
                    },
                    "firstName": {
                        "type": ["string", "null"],
                        "title": "First Name"
                    },
                    "middleName": {
                        "type": ["string", "null"],
                        "title": "Middle Name"
                    },
                    "addressLine1": {
                        "type": ["string", "null"],
                        "title": "Address Line 1"
                    },
                    "addressLine2": {
                        "type": ["string", "null"],
                        "title": "Address Line 2"
                    },
                    "city": {
                        "type": ["string", "null"],
                        "title": "City"
                    },
                    "stateAbbrev": {
                        "type": ["string", "null"],
                        "title": "State Abbreviation"
                    },
                    "postalCode": {
                        "type": ["string", "null"],
                        "title": "Postal Code"
                    },
                    "countryCode": {
                        "type": ["string", "null"],
                        "title": "Country Code"
                    },
                    "ssn": {
                        "type": ["string", "null"],
                        "title": "SSN"
                    },
                    "dob": {
                        "type": ["string", "null"],
                        "title": "Date of Birth",
                        "description": "Use ISO 8601 date format (YYYY-MM-DD)."
                    },
                    "gender": {
                        "type": ["string", "null"],
                        "title": "Gender",
                        "description": "Allowed values: M, F, U (Unknown/other).",
                        "enum": [
                            "M",
                            "F",
                            "U"
                        ]
                    },
                    "homePhone": {
                        "type": ["string", "null"],
                        "title": "Home Phone",
                        "description": "Use standardized E.164 format (example: +12145551234)."
                    },
                    "businessPhone": {
                        "type": ["string", "null"],
                        "title": "Business Phone",
                        "description": "Use standardized E.164 format (example: +12145551234)."
                    },
                    "relToPatient": {
                        "type": ["string", "null"],
                        "title": "Relationship to Patient",
                        "description": "Relationship to the patient"
                    },
                    "employmentStatus": {
                        "type": ["string", "null"],
                        "title": "Employment Status"
                    },
                    "type": {
                        "type": ["string", "null"],
                        "title": "Type"
                    },
                    "maritalStatus": {
                        "type": ["string", "null"],
                        "title": "Marital Status"
                    },
                    "occupation": {
                        "type": ["string", "null"],
                        "title": "Occupation"
                    },
                    "primaryLanguage": {
                        "type": ["string", "null"],
                        "title": "Primary Language"
                    },
                    "employerLastName": {
                        "type": ["string", "null"],
                        "title": "Employer Last Name"
                    },
                    "employerFirstName": {
                        "type": ["string", "null"],
                        "title": "Employer First Name"
                    },
                    "employerMiddleName": {
                        "type": ["string", "null"],
                        "title": "Employer Middle Name"
                    },
                    "employerAddress1": {
                        "type": ["string", "null"],
                        "title": "Employer Address 1"
                    },
                    "employerAddress2": {
                        "type": ["string", "null"],
                        "title": "Employer Address 2"
                    },
                    "employerPostalCode": {
                        "type": ["string", "null"],
                        "title": "Employer Postal Code"
                    },
                    "employerCity": {
                        "type": ["string", "null"],
                        "title": "Employer City"
                    },
                    "employerStateAbbrev": {
                        "type": ["string", "null"],
                        "title": "Employer State Abbreviation"
                    },
                    "employerCountryCode": {
                        "type": ["string", "null"],
                        "title": "Employer Country Code"
                    },
                    "employerPhone": {
                        "type": ["string", "null"],
                        "title": "Employer Phone",
                        "description": "Use standardized E.164 format (example: +12145551234)."
                    }
                }
            }
        }
    },
    "description": "Normalization rules: 1) All date fields must be ISO 8601 date format (YYYY-MM-DD). 2) All time-only fields must be 24-hour HH:mm format (no seconds). 3) All phone number fields must use standardized E.164 format (example: +12145551234). 4) All gender fields must be one of: M, F, U (Unknown/other)."
} as const;

export type JsonSchemaRecord = Record<string, any>;

export interface EntityMappingSchemaValidationOptions {
    allowEntityCreation?: boolean;
}

export interface EntityMappingSchemaValidationResult {
    valid: boolean;
    errors: string[];
    normalizedSchema: JsonSchemaRecord | null;
}

export const encounterEntityMappingTemplateFields = {
    faceSheet: ['enctrNo', 'patMrn', 'patLastNm', 'patFrstNm', 'patDob', 'admitDt', 'admitTm'],
    driversLicense: ['patFrstNm', 'patLastNm', 'patDob', 'patDrLicNo', 'patDrLicSt', 'patDrLicExp'],
    insuranceCard: ['enctrInsuranceDoc'],
} as const;

function isRecord(value: unknown): value is JsonSchemaRecord {
    return !!value && typeof value === 'object' && !Array.isArray(value);
}

function cloneRecord<T>(value: T): T {
    return value === null || value === undefined ? value : JSON.parse(JSON.stringify(value));
}

function stripUiMetadata(value: unknown): unknown {
    if (Array.isArray(value)) {
        return value.map(stripUiMetadata);
    }

    if (!isRecord(value)) {
        return value;
    }

    return Object.entries(value).reduce((result, [key, childValue]) => {
        if (key === 'title' || key === 'description') {
            return result;
        }
        result[key] = stripUiMetadata(childValue);
        return result;
    }, {} as JsonSchemaRecord);
}

function normalizeNullableKeyword(value: unknown): unknown {
    if (Array.isArray(value)) {
        return value.map(normalizeNullableKeyword);
    }

    if (!isRecord(value)) {
        return value;
    }

    const result = Object.entries(value).reduce((normalized, [key, childValue]) => {
        if (key !== 'nullable') {
            normalized[key] = normalizeNullableKeyword(childValue);
        }
        return normalized;
    }, {} as JsonSchemaRecord);

    if (value.nullable === true && typeof value.type === 'string') {
        result.type = [value.type, 'null'];
    }

    return result;
}

function deepEqual(left: unknown, right: unknown): boolean {
    if (left === right) {
        return true;
    }
    if (Array.isArray(left) || Array.isArray(right)) {
        if (!Array.isArray(left) || !Array.isArray(right) || left.length !== right.length) {
            return false;
        }
        return left.every((leftValue, index) => deepEqual(leftValue, right[index]));
    }
    if (isRecord(left) || isRecord(right)) {
        if (!isRecord(left) || !isRecord(right)) {
            return false;
        }
        const leftKeys = Object.keys(left);
        const rightKeys = Object.keys(right);
        if (leftKeys.length !== rightKeys.length) {
            return false;
        }
        return leftKeys.every((key) => Object.prototype.hasOwnProperty.call(right, key) && deepEqual(left[key], right[key]));
    }
    return false;
}

function schemasMatchExceptUiMetadata(candidate: unknown, canonical: unknown): boolean {
    return deepEqual(
        stripUiMetadata(normalizeNullableKeyword(candidate)),
        stripUiMetadata(normalizeNullableKeyword(canonical)),
    );
}

function getCanonicalProperties(): JsonSchemaRecord {
    return (encounterEntityMappingBaseSchema.properties || {}) as JsonSchemaRecord;
}

export function getEncounterEntityMappingAllowedFields(): string[] {
    return Object.keys(getCanonicalProperties());
}

export function buildEncounterEntityMappingSchemaSubset(fieldNames: readonly string[]): JsonSchemaRecord {
    const canonicalProperties = getCanonicalProperties();
    const selectedProperties = fieldNames.reduce((properties, fieldName) => {
        if (canonicalProperties[fieldName]) {
            properties[fieldName] = cloneRecord(canonicalProperties[fieldName]);
        }
        return properties;
    }, {} as JsonSchemaRecord);

    return {
        $schema: encounterEntityMappingBaseSchema.$schema,
        type: 'object',
        additionalProperties: false,
        properties: selectedProperties,
    };
}

export function validateEncounterEntityMappingSchema(
    schema: unknown,
    _options: EntityMappingSchemaValidationOptions = {},
): EntityMappingSchemaValidationResult {
    const errors: string[] = [];

    if (!isRecord(schema)) {
        return {
            valid: false,
            errors: ['Entity mapping schema must be a JSON object schema'],
            normalizedSchema: null,
        };
    }

    if (schema.type !== 'object') {
        errors.push('Entity mapping schema root type must be object');
    }

    if (!isRecord(schema.properties)) {
        errors.push('Entity mapping schema must include a properties object');
    }

    const canonicalProperties = getCanonicalProperties();
    const candidateProperties = isRecord(schema.properties) ? schema.properties : {};
    const selectedFieldNames = Object.keys(candidateProperties);

    if (selectedFieldNames.length === 0) {
        errors.push('Entity mapping schema must include at least one encounter field');
    }

    for (const fieldName of selectedFieldNames) {
        const canonicalProperty = canonicalProperties[fieldName];
        if (!canonicalProperty) {
            errors.push(`Entity mapping schema field is not supported for encounter updates: ${fieldName}`);
            continue;
        }

        if (!schemasMatchExceptUiMetadata(candidateProperties[fieldName], canonicalProperty)) {
            errors.push(`Entity mapping schema field must match the canonical encounter field shape: ${fieldName}`);
        }
    }

    if (schema.required !== undefined) {
        if (!Array.isArray(schema.required) || schema.required.some((fieldName) => typeof fieldName !== 'string')) {
            errors.push('Entity mapping schema required must be an array of selected field names');
        } else {
            const selectedFieldSet = new Set(selectedFieldNames);
            for (const requiredFieldName of schema.required) {
                if (!selectedFieldSet.has(requiredFieldName)) {
                    errors.push(`Entity mapping schema required field is not selected: ${requiredFieldName}`);
                }
            }
        }
    }

    if (errors.length) {
        return {
            valid: false,
            errors,
            normalizedSchema: null,
        };
    }

    const normalizedSchema: JsonSchemaRecord = {
        ...(typeof schema.$schema === 'string' ? { $schema: schema.$schema } : {}),
        type: 'object',
        additionalProperties: false,
        properties: selectedFieldNames.reduce((properties, fieldName) => {
            properties[fieldName] = normalizeNullableKeyword(candidateProperties[fieldName]);
            return properties;
        }, {} as JsonSchemaRecord),
        ...(Array.isArray(schema.required) ? { required: [...schema.required] } : {}),
        ...(typeof schema.title === 'string' ? { title: schema.title } : {}),
        ...(typeof schema.description === 'string' ? { description: schema.description } : {}),
    };

    return {
        valid: true,
        errors: [],
        normalizedSchema,
    };
}

export function normalizeEncounterEntityMappingSchema(
    schema: unknown,
    options: EntityMappingSchemaValidationOptions = {},
): JsonSchemaRecord {
    const validation = validateEncounterEntityMappingSchema(schema, options);
    if (!validation.valid || !validation.normalizedSchema) {
        throw new Error(`Invalid entity mapping schema: ${validation.errors.join('; ')}`);
    }
    return validation.normalizedSchema;
}

export function buildDocumentScanStructuredOutputSchema(
    extractionSchema: unknown,
    entityMappingSchema: unknown,
): JsonSchemaRecord {
    const extractedDataSchema = isRecord(extractionSchema)
        ? extractionSchema
        : {
              type: 'object',
              additionalProperties: true,
          };
    const entityDataSchema = isRecord(entityMappingSchema)
        ? entityMappingSchema
        : {
              type: 'object',
              additionalProperties: false,
              properties: {},
          };

    return {
        type: 'object',
        additionalProperties: false,
        required: ['extractedData', 'entityData'],
        properties: {
            extractedData: extractedDataSchema,
            entityData: entityDataSchema,
        },
    };
}
